import { Alignment } from "./Alignment"

export function getAlignmentContentClassName(alignment: Alignment) {
  switch (alignment) {
    case Alignment.BLOCK:
      return "w-100"
    default:
      return ""
  }
}
